import Course from "./Course"
import { txt } from "../../services/translation"

export default function Card({course}){

    return <Course 
        key={course.id}
        id={course.id}
        siret={course.siret}
        picture={course.picture?.url}
        pi={course.pi}
        title={course.title}
        subtitle={course.teachers}
        program={course.link}
        rating={course.reviews?.average || 0}
        badges={course.badges}
        button={txt('enrollButton')}
        link={course.customEnrollUrl || `/courses/${course.id}/enroll`}
        shareLink={course.enrollUrl}
        alert={!course.published && ['warning', txt('unpublishedWarning')]}
        editable={course.editable}
    />

}